module.exports = __webpack_public_path__ + "static/media/header.c8d2f90a.jpg";